import getCsrfToken from '../../lib/csrfToken';
import Inquiry from '../containers/Inquiry';

async function createInquiry(data: Inquiry, dryRun: boolean, extendExpiration: boolean) {
  const formData = data.buildFormData();
  formData.append('dry_run', dryRun.toString())
  formData.append('extend_expiration', extendExpiration.toString())

  const token_path = '/api/users/csrf_cookie';
  const token_resp = await fetch(token_path);

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch('/api/asebi/inquiries', {
    method: 'POST',
    headers: headers,
    body: formData
  });
  const json = await resp.json();
  // data.load(json);
  return [resp.status, json];
}

export default createInquiry;
